import "./navbar.scss";
import skytkd from "../../assets/images/skytkd.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebook,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import Hamburger from "./Hamburger/hamburger";
import { Link, NavLink } from "react-router-dom";

export default function Navbar() {
  return (
    <>
      <div className="navbar-section">
        <div className="container navbar-container">
          <div className="flex navbar-flex">
            <div className="logo">
              <Link to="/">
                <img className="img-logo" src={skytkd} alt="skytkd" />{" "}
              </Link>
              <Link to="/">
                <h1 className="sky">SKY TAEKWONDO</h1>
              </Link>
              <div className="flex email">
                <a href="tel:(908) 917-1336">
                  <h3 className="top-phone-number">(908) 917-1336</h3>
                </a>
                <h3>&nbsp; | &nbsp;</h3>
                <a href="mailto:pskyman1@gmail.com">
                  <h3 className="top-phone-number">pskyman1@gmail.com</h3>
                </a>
              </div>
            </div>
            <div className="socials-bar">
              <nav className="links main-links">
                <NavLink
                  to="/"
                  end
                  className={({ isActive }) =>
                    isActive ? "nav-item active" : "nav-item"
                  }
                >
                  <h1>Home</h1>
                </NavLink>
                <NavLink
                  to="/instructors"
                  className={({ isActive }) =>
                    isActive ? "nav-item active" : "nav-item"
                  }
                >
                  <h1>Instructors</h1>
                </NavLink>
                <NavLink
                  to="/schedule"
                  className={({ isActive }) =>
                    isActive ? "nav-item active" : "nav-item"
                  }
                >
                  <h1>Schedule</h1>
                </NavLink>
                <NavLink
                  to="/reviews"
                  className={({ isActive }) =>
                    isActive ? "nav-item active" : "nav-item"
                  }
                >
                  <h1>Reviews</h1>
                </NavLink>
                <Link to="/#programs" className="nav-item">
                  <h1>Programs</h1>
                </Link>
                <Link to="/#trial" className="nav-cta">
                  Free Trial
                </Link>
              </nav>
              <div className="nav-socials">
                <a
                  className="facebook"
                  href="https://www.facebook.com/baskingridgeskytkd/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Sky Taekwondo on Facebook"
                >
                  <FontAwesomeIcon icon={faFacebook} className="icon" />
                </a>
                <a
                  className="youtube"
                  href="https://www.youtube.com/@skytaekwondo770"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Sky Taekwondo on YouTube"
                >
                  <FontAwesomeIcon icon={faYoutube} className="icon" />
                </a>
                <a
                  className="instagram"
                  href="https://www.instagram.com/skytaekwondonj/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Sky Taekwondo on Instagram"
                >
                  <FontAwesomeIcon icon={faInstagram} className="icon" />
                </a>
              </div>
              <Hamburger />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
